import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useWalletDebits = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.walletDebits, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getWalletDebits(), {
        params,
      });

      const composeResponse = {
        clinics: res.data.data.clinics,
        clinicWalletDebits: res.data.data.clinic_wallet_debits,
        providerWalletDebits: res.data.data.provider_wallet_debits,
      };
      return composeResponse;
    },
    options,
  );
};
